import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Checkbox,
  FormControl,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import data from "../data/data";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LargeExportModal from "../components/LargeExportModal";

const Export = () => {
  const location = useLocation();
  const exportData = location?.state?.exportData;

  const [isPhoneNumberOnly, setIsPhoneNumberOnly] = useState(false);
  const [isSameHouseHold, setIsSameHouseHold] = useState(false);
  const [isEmailPresent, setIsEmailPresent] = useState(false);
  const [isGisEnabled, setIsGisEnabled] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [selectedFields, setSelectedFields] = useState([]);
  const [selectedRow, setSelectedRow] = useState(
    JSON.parse(localStorage.getItem("selectedRow")) || null
  );
  const [exports, setExports] = useState(
    JSON.parse(localStorage.getItem("savedSearches")) || []
  );
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [progress, setProgress] = useState(0);
  const [exporting, setExporting] = useState(false);
  const [email, setEmail] = useState("");
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [exportSizeInfo, setExportSizeInfo] = useState(null);
  const [modalEmail, setModalEmail] = useState("");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleModalEmailChange = (event) => {
    setModalEmail(event.target.value);
  };

  const updateProgressBar = (percentage) => {
    const progressBar = document.getElementById("progressBar");
    if (progressBar) {
      progressBar.style.width = `${percentage}%`;
      progressBar.innerText = `${percentage}%`;
    }
  };
  const formatFilenameTimestamp = (date = new Date()) => {
    const pad = (n) => String(n).padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
  };
  const electionFields = [
    "2008_GENERAL",
    "2008_GENERAL_PARTY",
    "2008_PRIMARY",
    "2008_PRIMARY_PARTY",
    "2009_GENERAL",
    "2009_GENERAL_PARTY",
    "2009_PRIMARY",
    "2009_PRIMARY_PARTY",
    "2010_GENERAL",
    "2010_GENERAL_PARTY",
    "2010_PRIMARY",
    "2010_PRIMARY_PARTY",
    "2011_GENERAL",
    "2011_GENERAL_PARTY",
    "2011_PRIMARY",
    "2011_PRIMARY_PARTY",
    "2012_GENERAL",
    "2012_GENERAL_PARTY",
    "2012_PRIMARY",
    "2012_PRIMARY_PARTY",
    "2013_GENERAL",
    "2013_GENERAL_PARTY",
    "2013_PRIMARY",
    "2013_PRIMARY_PARTY",
    "2014_GENERAL",
    "2014_GENERAL_PARTY",
    "2014_PRIMARY",
    "2014_PRIMARY_PARTY",
    "2015_GENERAL",
    "2015_GENERAL_PARTY",
    "2015_PRIMARY",
    "2015_PRIMARY_PARTY",
    "2016_GENERAL",
    "2016_GENERAL_PARTY",
    "2016_PRIMARY",
    "2016_PRIMARY_PARTY",
    "2017_GENERAL",
    "2017_GENERAL_PARTY",
    "2017_PRIMARY",
    "2017_PRIMARY_PARTY",
    "2018_GENERAL",
    "2018_GENERAL_PARTY",
    "2018_PRIMARY",
    "2018_PRIMARY_PARTY",
    "2019_GENERAL",
    "2019_GENERAL_PARTY",
    "2019_PRIMARY",
    "2019_PRIMARY_PARTY",
    "2020_GENERAL",
    "2020_GENERAL_PARTY",
    "2020_PRIMARY",
    "2020_PRIMARY_PARTY",
    "2021_GENERAL",
    "2021_GENERAL_PARTY",
    "2021_PRIMARY",
    "2021_PRIMARY_PARTY",
    "2022_GENERAL",
    "2022_GENERAL_PARTY",
    "2022_PRIMARY",
    "2022_PRIMARY_PARTY",
    "2023_PRIMARY",
    "2023_PRIMARY_PARTY",
    "2023_GENERAL",
    "2023_GENERAL_PARTY",
    "2024_GENERAL",
    "2024_GENERAL_PARTY",
    "2024_PRIMARY",
    "2024_PRIMARY_PARTY",
    "2025_GENERAL",
    "2025_GENERAL_PARTY",
    "2025_PRIMARY",
    "2025_PRIMARY_PARTY",
  ];
  const [snackbarMessage, setSnackbarMessage] = useState("");
  
  const handleExport = async () => {
    try {
      if (!selectedRow || !selectedRow.search) {
        setSnackbarOpen(true);
        setSnackbarMessage("Please select an export profile.");
        return;
      }

      if (!exportData) {
        setSnackbarOpen(true);
        setSnackbarMessage("No filter data available. Please apply filters from the search page first.");
        return;
      }

      setExporting(true);

      // Determine export options based on checkboxes
      const exportOptions = {
        phoneOnly: isPhoneNumberOnly,
        emailOnly: isEmailPresent,
        includeHousehold: isSameHouseHold,
        gisEnabled: isGisEnabled
      };

      console.log('Sending export data:', exportData);
      console.log('Export options:', exportOptions);

      // Step 1: Check export size
      const sizeCheckResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/export/check-size`,
        {
          filters: exportData,
          exportOptions: exportOptions
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const { isLarge, rowCount, estimatedParts } = sizeCheckResponse.data;

      if (isLarge) {
        // Show email modal for large exports
        setExportSizeInfo({ rowCount, estimatedParts });
        setShowEmailModal(true);
        setExporting(false);
      } else {
        // Direct download for small exports
        const selectedFields = selectedRow.search.split(",").map((field) => field.trim());
        
        const downloadResponse = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/export/download`,
          {
            filters: exportData,
            selectedFields: selectedFields,
            exportOptions: exportOptions
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
            responseType: 'blob'
          }
        );

        // Download the file
        const blob = new Blob([downloadResponse.data], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;
        const timestamp = formatFilenameTimestamp();
        link.setAttribute('download', `voters_export_${timestamp}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        setSnackbarOpen(true);
        setSnackbarMessage(`Export complete - ${rowCount.toLocaleString()} records downloaded`);
        setExporting(false);
      }
    } catch (error) {
      console.error("Error exporting data:", error);
      setSnackbarOpen(true);
      
      if (error.response?.status === 400 && error.response?.data?.error) {
        // Handle "No data to export" error
        setSnackbarMessage(error.response.data.error);
      } else if (error.response?.data?.error) {
        setSnackbarMessage(`Error: ${error.response.data.error}`);
      } else {
        setSnackbarMessage("Error exporting data. Please try again.");
      }
      
      setExporting(false);
    }
  };

  const handleEmailExport = async () => {
    try {
      if (!modalEmail || !modalEmail.trim()) {
        setSnackbarOpen(true);
        setSnackbarMessage("Please enter an email address.");
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(modalEmail)) {
        setSnackbarOpen(true);
        setSnackbarMessage("Please enter a valid email address.");
        return;
      }

      setExporting(true);

      const selectedFields = selectedRow.search.split(",").map((field) => field.trim());
      
      const exportOptions = {
        phoneOnly: isPhoneNumberOnly,
        emailOnly: isEmailPresent,
        includeHousehold: isSameHouseHold,
        gisEnabled: isGisEnabled
      };

      const emailResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/export/email`,
        {
          filters: exportData,
          email: modalEmail,
          selectedFields: selectedFields,
          exportOptions: exportOptions
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setShowEmailModal(false);
      setModalEmail("");
      setExporting(false);
      setSnackbarOpen(true);
      setSnackbarMessage(
        `Export is being processed. You will receive an email with a download link at ${modalEmail}`
      );
    } catch (error) {
      console.error("Error queuing export:", error);
      setSnackbarOpen(true);
      setSnackbarMessage("Error queuing export. Please try again.");
      setExporting(false);
    }
  };

  const handleCloseModal = () => {
    setShowEmailModal(false);
    setModalEmail("");
    setExporting(false);
  };

  const getUniqueOptions = (filter) => {
    switch (filter) {
      case "Fields":
        return [...new Set(data.map((item) => item.field))];
      default:
        return [];
    }
  };

  const handleChange = (filter, newValue) => {
    setSelectedFilter(filter);

    if (filter === "Fields") {
      setSelectedFields(newValue || []);
    }
  };

  const handleSaveSearch = () => {
    if (
      selectedFilter === "Fields" &&
      selectedFields.length > 0 &&
      searchName
    ) {
      const newExport = {
        name: searchName,
        search: selectedFields.join(", "),
        lastUpdated: new Date().toLocaleString(),
      };

      setExports((prevExports) => [...prevExports, newExport]);

      localStorage.setItem(
        "savedSearches",
        JSON.stringify([...exports, newExport])
      );

      setSearchName("");
      setSelectedFields([]);
    }
  };

  const handleCheckboxChange = (checkboxName) => {
    switch (checkboxName) {
      case "isPhoneNumberOnly":
        setIsPhoneNumberOnly((prev) => !prev);
        break;
      case "isSameHouseHold":
        setIsSameHouseHold((prev) => !prev);
        break;
      case "isEmailPresent":
        setIsEmailPresent((prev) => !prev);
        break;
      case "isGisEnabled":
        setIsGisEnabled((prev) => !prev);
        break;
      default:
        break;
    }
  };

  const handleDragStartFields = () => {
    document.body.style.cursor = "grabbing";
    document.body.style.userSelect = "none";
  };

  const handleDragEndFields = (result) => {
    document.body.style.cursor = "auto";
    document.body.style.userSelect = "auto";

    if (!result.destination) {
      return;
    }

    const reorderedFields = Array.from(selectedFields);
    const [removed] = reorderedFields.splice(result.source.index, 1);
    reorderedFields.splice(result.destination.index, 0, removed);

    setSelectedFields(reorderedFields);
  };

  const handleDragUpdateFields = (result) => {
    if (result.destination) {
      const reorderedFields = Array.from(selectedFields);
      const [removed] = reorderedFields.splice(result.source.index, 1);
      reorderedFields.splice(result.destination.index, 0, removed);

      setSelectedFields(reorderedFields);
    }
  };
  const [isEditing, setIsEditing] = useState(false);

  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);

  const toggleEditMode = (index) => {
    setIsEditing(!isEditing);
    setSelectedRowIndex(index);
    if (!isEditing) {
      setSearchName("");
      setSelectedFields([]);
    }
  };

  const handleSaveEdit = () => {
    const updatedExports = exports.map((exportItem, index) => {
      if (index === selectedRowIndex) {
        return {
          ...exportItem,
          name: searchName,
          search: selectedFields.join(", "),
          lastUpdated: new Date().toLocaleString(),
        };
      }
      return exportItem;
    });

    setExports(updatedExports);
    localStorage.setItem("savedSearches", JSON.stringify(updatedExports));

    setIsEditing(false);
    setSelectedRowIndex(-1);
    setSearchName("");
    setSelectedFields([]);
  };

  const handleCancelEdit = (index) => {
    toggleEditMode(index);
    setSelectedFields([]);
    setSearchName("");
  };
  const handleCancel = () => {
    setSelectedFields([]);
    setSearchName("");
  };

  const handleEditExport = (index) => {
    const exportToEdit = exports[index];
    setSelectedRowIndex(index);
    setSearchName(exportToEdit.name);
    setSelectedFields(exportToEdit.search.split(", "));
    toggleEditMode(index);
    console.log(exportToEdit);
  };

  const handleDeleteExport = (index) => {
    const updatedExports = [...exports];
    updatedExports.splice(index, 1);

    setExports(updatedExports);

    localStorage.setItem("savedSearches", JSON.stringify(updatedExports));
  };
  const handleRowClick = (row) => {
    setSelectedRow(row);
    localStorage.setItem("selectedRow", JSON.stringify(row));
  };
  useEffect(() => {
    if (selectedRowIndex !== -1) {
      const exportToEdit = exports[selectedRowIndex];
      setSearchName(exportToEdit.name);
      setSelectedFields(exportToEdit.search.split(", "));
    }
  }, [selectedRowIndex, exports]);
  useEffect(() => {
    const allFields = data.map((item) => item.field);
    const defaultProfile = {
      name: "Default Profile",
      search: allFields.join(", "),
      lastUpdated: new Date().toLocaleString(),
    };
    
    const savedSearches = JSON.parse(localStorage.getItem("savedSearches")) || [];
    
    if (savedSearches.length === 0) {
      // No saved searches, create default profile
      const newExports = [defaultProfile];
      setExports(newExports);
      localStorage.setItem("savedSearches", JSON.stringify(newExports));
      setSelectedRow(defaultProfile);
      localStorage.setItem("selectedRow", JSON.stringify(defaultProfile));
    } else {
      // Update the default profile if it exists
      const updatedExports = savedSearches.map(exp => 
        exp.name === "Default Profile" ? defaultProfile : exp
      );
      
      if (updatedExports.some(exp => exp.name === "Default Profile")) {
        setExports(updatedExports);
        localStorage.setItem("savedSearches", JSON.stringify(updatedExports));
        
        // Always select the default profile from the updated list
        const defaultProfileInList = updatedExports.find(exp => exp.name === "Default Profile");
        if (defaultProfileInList) {
          setSelectedRow(defaultProfileInList);
          localStorage.setItem("selectedRow", JSON.stringify(defaultProfileInList));
        }
      } else {
        setExports(savedSearches);
      }
    }
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  return (
    <div className="bg-gray-100 min-h-screen p-2 sm:p-4 md:p-6">
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
      
      {/* Back Button */}
      <div className="mb-4">
        <Button
          variant="outlined"
          onClick={() => window.history.back()}
          style={{ textTransform: 'none' }}
        >
          BACK
        </Button>
      </div>

      <div className="flex flex-col lg:flex-row space-y-4 lg:space-y-0 lg:space-x-4">
        {/* Left Side - Export Options */}
        <div className="flex-1 w-full lg:w-auto">
          <Card elevation={3} className="w-full">
            <CardContent>
              <Typography variant="h6" className="mb-4">
                Export Options
              </Typography>
              
              <div className="mb-4">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isPhoneNumberOnly}
                      onChange={() => handleCheckboxChange("isPhoneNumberOnly")}
                    />
                  }
                  label="Only records with phone numbers"
                />
              </div>
              <div className="mb-4">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isEmailPresent}
                      onChange={() => handleCheckboxChange("isEmailPresent")}
                    />
                  }
                  label="Only records with email"
                />
              </div>
              <div className="mb-4">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSameHouseHold}
                      onChange={() => handleCheckboxChange("isSameHouseHold")}
                    />
                  }
                  label="Include other members in the same household"
                />
              </div>
              <div className="mb-4">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isGisEnabled}
                      onChange={() => handleCheckboxChange("isGisEnabled")}
                    />
                  }
                  label="Get Lat and Longitude of each address (GIS)"
                />
              </div>

              {/* Desktop Table View */}
              <TableContainer className="my-4 hidden lg:block" style={{ backgroundColor: 'white', borderRadius: '4px', overflowX: 'auto' }}>
                <Table style={{ tableLayout: 'fixed', width: '100%', minWidth: '600px' }}>
                  <TableHead>
                    <TableRow style={{ borderBottom: '2px solid #e0e0e0' }}>
                      <TableCell style={{ fontWeight: 600, fontSize: '16px', padding: '12px 24px', color: '#333', width: '33.33%' }}>
                        Export Profile
                      </TableCell>
                      <TableCell style={{ fontWeight: 600, fontSize: '16px', padding: '12px 24px', color: '#333', width: '33.33%', textAlign: 'center' }}>
                        Last Updated
                      </TableCell>
                      <TableCell style={{ fontWeight: 600, fontSize: '16px', padding: '12px 24px', color: '#333', width: '33.33%', textAlign: 'center' }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {exports.map((exportItem, index) => (
                      <TableRow
                        key={index}
                        onClick={() => handleRowClick(exportItem)}
                        style={{
                          cursor: "pointer",
                          backgroundColor:
                            selectedRow === exportItem
                              ? "#d6eef7"
                              : "transparent",
                          borderBottom: '1px solid #e0e0e0'
                        }}
                      >
                        <TableCell style={{ padding: '12px 24px', fontSize: '15px', color: '#666', width: '33.33%' }}>{exportItem.name}</TableCell>
                        <TableCell style={{ padding: '12px 24px', fontSize: '15px', color: '#666', width: '33.33%', textAlign: 'center' }}>
                          {exportItem.lastUpdated}
                        </TableCell>
                        <TableCell style={{ padding: '12px 24px', width: '33.33%' }}>
                          {exportItem.name !== "Default Profile" && (
                            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                              <Button
                                variant="outlined"
                                onClick={() => handleEditExport(index)}
                                style={{
                                  textTransform: 'none',
                                  borderColor: '#1976d2',
                                  color: '#1976d2',
                                  padding: '6px 20px',
                                  fontSize: '14px',
                                  fontWeight: 500
                                }}
                                className="min-w-[70px]"
                              >
                                Edit
                              </Button>
                              <Button
                                variant="outlined"
                                onClick={() => handleDeleteExport(index)}
                                style={{
                                  textTransform: 'none',
                                  borderColor: '#d32f2f',
                                  color: '#d32f2f',
                                  padding: '6px 20px',
                                  fontSize: '14px',
                                  fontWeight: 500
                                }}
                                className="min-w-[70px]"
                              >
                                Delete
                              </Button>
                            </div>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Mobile Card View */}
              <div className="my-4 lg:hidden" style={{ backgroundColor: 'white', borderRadius: '8px', overflow: 'hidden' }}>
                {exports.map((exportItem, index) => (
                  <div
                    key={index}
                    onClick={() => handleRowClick(exportItem)}
                    style={{
                      backgroundColor: selectedRow === exportItem ? "#d6eef7" : "white",
                      padding: '16px 20px',
                      borderBottom: index < exports.length - 1 ? '1px solid #e0e0e0' : 'none',
                      cursor: 'pointer',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                      <Typography style={{ fontSize: '16px', fontWeight: 400, color: '#666', flex: 1 }}>
                        {exportItem.name}
                      </Typography>
                      {exportItem.name !== "Default Profile" && (
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginLeft: '16px' }}>
                          <Button
                            variant="text"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditExport(index);
                            }}
                            style={{
                              textTransform: 'none',
                              color: '#2196f3',
                              fontSize: '14px',
                              fontWeight: 400,
                              padding: '0',
                              minWidth: 'auto'
                            }}
                          >
                            Edit
                          </Button>
                          <span style={{ color: '#999', fontSize: '14px' }}>|</span>
                          <Button
                            variant="text"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteExport(index);
                            }}
                            style={{
                              textTransform: 'none',
                              color: '#f44336',
                              fontSize: '14px',
                              fontWeight: 400,
                              padding: '0',
                              minWidth: 'auto'
                            }}
                          >
                            Delete
                          </Button>
                        </div>
                      )}
                    </div>
                    <Typography style={{ fontSize: '14px', color: '#999', fontWeight: 400 }}>
                      {exportItem.lastUpdated}
                    </Typography>
                  </div>
                ))}
              </div>

              <div className="flex justify-end mt-4">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleExport}
                  disabled={exporting}
                  startIcon={exporting && <CircularProgress size={20} color="inherit" />}
                  style={{ textTransform: 'uppercase', minWidth: '150px' }}
                >
                  {exporting ? "Processing..." : "EXPORT"}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Right Side - Create Export Profile */}
        <div className="flex-1 w-full lg:w-auto">
          <Card elevation={3} className="w-full">
            <CardContent>
              <div className="space-y-3">
                <Typography variant="h6" className="mb-4">
                  {isEditing ? "Edit Export Profile" : "Create Export Profile"}
                </Typography>
                {isEditing ? (
                  <>
                    <TextField
                      label="Profile Name"
                      variant="outlined"
                      fullWidth
                      value={searchName}
                      onChange={(e) => setSearchName(e.target.value)}
                    />
                    <FormControl variant="outlined" fullWidth>
                      <Autocomplete
                        options={data.map((item) => item.field)}
                        value={selectedFields}
                        onChange={(event, newValue) =>
                          setSelectedFields(newValue)
                        }
                        disableListWrap
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Fields"
                            variant="outlined"
                            margin="normal"
                            inputProps={{
                              ...params.inputProps,
                              "data-rbd-drag-handle-draggable-id":
                                "draggable-autocomplete",
                              "data-rbd-drag-handle": true,
                            }}
                          />
                        )}
                        multiple
                        disableCloseOnSelect
                      />
                    </FormControl>
                    <DragDropContext
                      onDragStart={handleDragStartFields}
                      onDragEnd={handleDragEndFields}
                      onDragUpdate={handleDragUpdateFields}
                    >
                      <Droppable
                        droppableId="droppable-fields"
                        direction="horizontal"
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              maxWidth: "100%",
                              width: "fit-content",
                              maxWidth: "100%",
                              overflow: "hidden",
                            }}
                          >
                            {selectedFields.map((field, index) => (
                              <Draggable
                                key={field}
                                draggableId={field}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={{
                                      margin: "5px 5px",
                                      backgroundColor: snapshot.isDragging
                                        ? "lightblue"
                                        : "lightgray",
                                      padding: "8px",
                                      borderRadius: "4px",
                                      cursor: "grab",
                                      transition: "background-color 0.2s",
                                      userSelect: "none",
                                      display: "flex",
                                      position: "relative",
                                      flexWrap: "wrap",
                                      alignItems: "center",
                                      width: "fit-content",
                                      maxWidth: "100%",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {field}
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                    <div className="flex flex-wrap gap-2 sm:gap-4 mt-3">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSaveEdit}
                        className="flex-1 sm:flex-none"
                      >
                        Save
                      </Button>
                      <Button variant="outlined" onClick={handleCancel} className="flex-1 sm:flex-none">
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => handleCancelEdit(selectedRowIndex)}
                        className="flex-1 sm:flex-none"
                      >
                        Cancel
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    <TextField
                      label="Create Export Profile"
                      variant="outlined"
                      fullWidth
                      value={searchName}
                      onChange={(e) => setSearchName(e.target.value)}
                    />

                    <FormControl variant="outlined" fullWidth>
                      <Autocomplete
                        options={getUniqueOptions("Fields")}
                        value={
                          selectedFilter === "Fields" ? selectedFields : []
                        }
                        onChange={(_, newValue) =>
                          handleChange("Fields", newValue)
                        }
                        disableListWrap
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Fields"
                            variant="outlined"
                            margin="normal"
                            inputProps={{
                              ...params.inputProps,
                              "data-rbd-drag-handle-draggable-id":
                                "draggable-autocomplete",
                              "data-rbd-drag-handle": true,
                            }}
                          />
                        )}
                        multiple
                        disableCloseOnSelect
                      />
                    </FormControl>
                    <DragDropContext
                      onDragStart={handleDragStartFields}
                      onDragEnd={handleDragEndFields}
                      onDragUpdate={handleDragUpdateFields}
                    >
                      <Droppable
                        droppableId="droppable-fields"
                        direction="horizontal"
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              maxWidth: "100%",
                              width: "fit-content",
                              maxWidth: "100%",
                              overflow: "hidden",
                            }}
                          >
                            {selectedFields.map((field, index) => (
                              <Draggable
                                key={field}
                                draggableId={field}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={{
                                      margin: "5px 5px",
                                      backgroundColor: snapshot.isDragging
                                        ? "lightblue"
                                        : "lightgray",
                                      padding: "8px",
                                      borderRadius: "4px",
                                      cursor: "grab",
                                      transition: "background-color 0.2s",
                                      userSelect: "none",
                                      display: "flex",
                                      position: "relative",
                                      flexWrap: "wrap",
                                      alignItems: "center",
                                      width: "fit-content",
                                      maxWidth: "100%",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {field}
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                    <div className="flex flex-wrap justify-end gap-2 mt-3">
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleCancel}
                        style={{ textTransform: 'uppercase' }}
                        className="flex-1 sm:flex-none min-w-[100px]"
                      >
                        RESET
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSaveSearch}
                        style={{ textTransform: 'uppercase' }}
                        className="flex-1 sm:flex-none min-w-[100px]"
                      >
                        SAVE
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Large File Email Modal */}
      <LargeExportModal
        open={showEmailModal}
        onClose={handleCloseModal}
        email={modalEmail}
        onEmailChange={handleModalEmailChange}
        onSend={handleEmailExport}
        exporting={exporting}
        exportSizeInfo={exportSizeInfo}
      />
    </div>
  );
};

export default Export;